import Link from "@/components/ui/RouterLink";
import { X, ChevronDown } from "lucide-react";
import { useState } from "react";
import { primaryNav, productMegaMenu } from "@/config/navigation";
import { whmcs } from "@/config/whmcs";
import { cn } from "@/lib/utils";

export function MobileNav({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [productsOpen, setProductsOpen] = useState(false);

  return (
    <div
      className={cn(
        "fixed inset-0 z-[60] bg-navy transition-opacity duration-200 md:hidden",
        open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
      )}
      role="dialog"
      aria-modal="true"
      aria-label="Mobile navigation"
    >
      <div className="flex items-center justify-between border-b border-border px-5 py-4">
        <span className="font-display text-sm font-semibold tracking-wide text-text-primary">
          THE PLANET
        </span>
        <button onClick={onClose} aria-label="Close menu" className="focus-ring text-text-secondary">
          <X className="h-6 w-6" />
        </button>
      </div>

      <nav className="flex flex-col gap-1 px-5 py-6">
        <button
          onClick={() => setProductsOpen((v) => !v)}
          className="focus-ring flex items-center justify-between rounded-lg px-3 py-3 text-base font-medium text-text-primary"
          aria-expanded={productsOpen}
        >
          Products
          <ChevronDown className={cn("h-4 w-4 transition", productsOpen && "rotate-180")} />
        </button>
        {productsOpen && (
          <div className="ml-3 mb-2 flex flex-col gap-1 border-l border-border pl-4">
            {productMegaMenu.flatMap((g) => g.items).map((item) => (
              <Link
                key={item.href}
                href={item.href}
                onClick={onClose}
                className="focus-ring rounded-md py-2 text-sm text-text-secondary hover:text-cyan"
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}

        {primaryNav
          .filter((n) => n.label !== "Products")
          .map((item) => (
            <Link
              key={item.href}
              href={item.href}
              onClick={onClose}
              className="focus-ring rounded-lg px-3 py-3 text-base font-medium text-text-primary hover:bg-navy-secondary"
            >
              {item.label}
            </Link>
          ))}
      </nav>

      <div className="mt-4 flex flex-col gap-3 border-t border-border px-5 py-6">
        <a
          href={whmcs.loginUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="focus-ring rounded-full border border-border px-5 py-3 text-center text-sm font-medium text-text-primary"
        >
          Client Login
        </a>
        <a
          href={whmcs.storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="focus-ring rounded-full bg-gradient-brand px-5 py-3 text-center text-sm font-medium text-white"
        >
          Get Started
        </a>
      </div>
    </div>
  );
}
